module.exports = __webpack_public_path__ + "static/media/pw-points-active-icon.b942c3dd.svg";